/** Prefix for same email twice (or more) inside one category. */
export const WITHIN_CATEGORY_DUPLICATE_PREFIX = "Duplicate email in this category:";

/** Suffix so Ant Design Select tags can show the same email twice (unique React keys). */
const NOTIFICATION_TAG_OCC_MARKER = "::__mogu__::";

/** Strip occurrence suffix from a Select tag value. */
export function decodeNotificationSelectTagValue(v) {
  const s = String(v);
  const marker = NOTIFICATION_TAG_OCC_MARKER;
  const i = s.lastIndexOf(marker);
  if (i === -1) return s.trim();
  const num = s.slice(i + marker.length);
  if (!/^\d+$/.test(num)) return s.trim();
  return s.slice(0, i).trim();
}

/** Build unique tag values from stored comma/newline-separated string (for controlled Select). */
export function encodeNotificationEmailsStringForSelect(str) {
  const parts = str ? str.split(/[,\n]/).map((e) => e.trim()).filter(Boolean) : [];
  const seen = {};
  return parts.map((email) => {
    const n = (seen[email] = (seen[email] || 0) + 1);
    return `${email}${NOTIFICATION_TAG_OCC_MARKER}${n}`;
  });
}

/** Join tag values back into comma-separated payload string. */
export function decodeNotificationSelectValuesToEmailsString(vals) {
  if (!vals || !vals.length) return "";
  return vals.map((v) => decodeNotificationSelectTagValue(v)).join(", ");
}

/**
 * @param {string} emailsStr - comma- and/or newline-separated addresses
 * @returns {string|null} error message or null
 */
export function getWithinCategoryEmailDuplicateError(emailsStr) {
  if (!emailsStr || !String(emailsStr).trim()) return null;
  const parts = String(emailsStr)
    .split(/[,\n]/)
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
  const seen = new Set();
  const dupes = new Set();
  for (const p of parts) {
    if (seen.has(p)) dupes.add(p);
    seen.add(p);
  }
  if (dupes.size === 0) return null;
  return `${WITHIN_CATEGORY_DUPLICATE_PREFIX} ${[...dupes].join(", ")}`;
}

/**
 * After the user edits one notification email field, clear that field's error and the section banner.
 */
export function mergeNotificationEmailFieldChange(prevErrors, changedPayloadKey) {
  return { ...prevErrors, notificationSection: "", [changedPayloadKey]: "" };
}
